// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
}

.user-profile-header h1 {
    font-size: 24px;
    font-weight: 600;
    color: #202124;
    margin: 0;
}

.actions-button {
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #dadce0;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #5f6368;
    transition: all 0.2s;
}

.actions-button:hover {
    background: #f8f9fa;
    border-color: #c6c6c6;
}

.user-profile-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 30px;
}

.profile-section,
.activity-section {
    background: white;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.profile-section h3,
.activity-section h3 {
    font-size: 16px;
    font-weight: 600;
    color: #202124;
    margin-bottom: 16px;
}

.profile-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    color: #5f6368;
    font-size: 14px;
}

.profile-item svg {
    color: #5f6368;
}

.subscriptions-section,
.ids-section,
.tags-section,
.automations-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.subscription-item {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px;
    margin-top: 12px;
}

.subscription-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.subscription-header>div {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #202124;
}

.subscription-badge {
    background: #e8eaed;
    color: #5f6368;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.id-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    font-size: 14px;
    color: #5f6368;
}

.copy-button,
.add-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #4346ce;
    margin-left: auto;
}

.copy-button:hover,
.add-button:hover {
    opacity: 0.7;
}

.add-tag-button {
    background: transparent;
    border: 1px solid #4346ce;
    color: #4346ce;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    margin-top: 12px;
    transition: all 0.2s;
}

.add-tag-button:hover {
    background: #f0f0ff;
}

.tags-list {
    margin-top: 16px;
}

.automations-link {
    margin: 0;
    color: #4346ce;
    font-size: 14px;
}

.activity-subtitle {
    color: #5f6368;
    font-size: 13px;
    margin-bottom: 16px;
}

.days-selector {
    margin-bottom: 24px;
}

.days-selector button {
    background: white;
    border: 1px solid #dadce0;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #5f6368;
}

.days-selector button.active {
    background: #e8f0fe;
    border-color: #4346ce;
    color: #4346ce;
}

.no-activity {
    text-align: center;
    padding: 60px 20px;
}

.no-activity-icon {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}

.no-activity h4 {
    font-size: 18px;
    font-weight: 600;
    color: #202124;
    margin-bottom: 8px;
}

.no-activity p {
    color: #5f6368;
    font-size: 14px;
}

@media (max-width: 1024px) {
    .user-profile-content {
        grid-template-columns: 1fr;
    }
}

/* Modal Styles */
/* .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.modal-content {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 550px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    border-bottom: 1px solid #e8eaed;
}

.modal-header h2 {
    font-size: 22px;
    font-weight: 500;
    color: #202124;
    margin: 0;
}

.modal-close {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #5f6368;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 50%;
    width: 40px;
    height: 40px;
}

.modal-close:hover {
    background: #f1f3f4;
    color: #202124;
}

.modal-body {
    padding: 32px 28px;
} */

.form-group {
    margin-bottom: 24px;
}

.form-group:last-child {
    margin-bottom: 0;
}

.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #5f6368;
    margin-bottom: 10px;
}

.form-input {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #dadce0;
    border-radius: 4px;
    font-size: 15px;
    color: #202124;
    transition: all 0.2s;
    box-sizing: border-box;
    font-family: inherit;
}

.form-input::placeholder {
    color: #9aa0a6;
}

.form-input:hover {
    border-color: #bdc1c6;
}

.form-input:focus {
    outline: none;
    border-color: #5f6df4;
    box-shadow: 0 0 0 3px rgba(95, 109, 244, 0.1);
}

/*
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 28px;
    background: #fafafa;
    border-top: 1px solid #e8eaed;
    border-radius: 0 0 8px 8px;
} */

.btn-cancel {
    background: transparent;
    border: none;
    color: #5f6df4;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    font-family: inherit;
}

.btn-cancel:hover {
    background: #e8eaff;
}

.btn-save {
    background: #5f6df4;
    border: none;
    color: white;
    padding: 10px 28px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    font-family: inherit;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.btn-save:hover:not(:disabled) {
    background: #4e5ce6;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.btn-save:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

/* Bootstrap Modal Overrides */
.modal.show {
    display: block;
}

.modal-dialog-centered {
    max-width: 550px;
}

.modal-title {
    font-size: 22px;
    font-weight: 500;
    color: #202124;
}

.modal-body .form-label {
    font-size: 14px;
    font-weight: 400;
    color: #5f6368;
    margin-bottom: 8px;
}


.modal-body .mb-3 {
    margin-bottom: 1.5rem;
}

/* Tag Dropdown Menu */
.tag-menu-wrapper {
    position: relative;
    display: inline-block;
}

.tag-menu-button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #5f6368;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
    line-height: 1;
}

.tag-menu-button:hover {
    background: #e8eaed;
    color: #202124;
}

.tag-dropdown {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    background: white;
    border: 1px solid #dadce0;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
    min-width: 168px;
    z-index: 1000;
    overflow: hidden;
    padding: 4px 0;
    animation: dropdownFadeIn 0.15s ease-out;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.tag-dropdown .dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.25;
    color: #3c4043;
    font-weight: 400;
}

.tag-dropdown .dropdown-item svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    display: block;
}

.tag-dropdown .dropdown-item:hover {
    background: #f1f3f4;
    color: #202124;
}

.tag-dropdown .dropdown-item:active {
    background: #e8eaed;
}

.tag-dropdown .dropdown-item.text-danger {
    color: #d93025;
}

.tag-dropdown .dropdown-item.text-danger:hover {
    background: #fce8e6;
    color: #c5221f;
}

.tag-dropdown .dropdown-item.text-danger:active {
    background: #f9dedc;
}

.tag-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 8px;
    font-size: 14px;
    transition: all 0.2s;
}

.tag-item:hover {
    background: #f1f3f4;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tag-item-content {
    display: flex;
    gap: 16px;
    flex: 1 1;
    align-items: center;
}

.tag-item-key {
    font-weight: 500;
    color: #202124;
    min-width: 120px;
}

.tag-item-value {
    color: #5f6368;
    flex: 1 1;
}

/* Activity Timeline Styles */
.activity-timeline {
    margin-top: 20px;
}

.activity-item {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    margin-bottom: 12px;
    overflow: hidden;
    transition: all 0.2s;
}

.activity-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.activity-item-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    background: white;
    transition: background 0.2s;
}

.activity-item-header:hover {
    background: #f8f9fa;
}

.activity-timestamp {
    font-size: 13px;
    color: #5f6368;
    min-width: 180px;
}

.activity-status {
    font-size: 14px;
    color: #202124;
    font-weight: 500;
    flex: 1 1;
}

.activity-details {
    padding: 16px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
}

.activity-details h4 {
    font-size: 14px;
    font-weight: 600;
    color: #202124;
    margin-bottom: 16px;
}

.activity-detail-row {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #e8eaed;
    font-size: 13px;
}

.activity-detail-row:last-child {
    border-bottom: none;
}

.detail-label {
    color: #5f6368;
    min-width: 140px;
    font-weight: 500;
}

.detail-value {
    color: #202124;
    flex: 1 1;
    word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/users/UserProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,iBAAiB;AACjB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgFG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;;;;;;;;;GASG;;AAEH;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yEAAyE;IACzE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAO;AACX;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAO;IACP,sBAAsB;AAC1B","sourcesContent":[".user-profile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.user-profile-header h1 {\n    font-size: 24px;\n    font-weight: 600;\n    color: #202124;\n    margin: 0;\n}\n\n.actions-button {\n    display: flex;\n    align-items: center;\n    background: white;\n    border: 1px solid #dadce0;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #5f6368;\n    transition: all 0.2s;\n}\n\n.actions-button:hover {\n    background: #f8f9fa;\n    border-color: #c6c6c6;\n}\n\n.user-profile-content {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 30px;\n}\n\n.profile-section,\n.activity-section {\n    background: white;\n    border-radius: 8px;\n    padding: 24px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.profile-section h3,\n.activity-section h3 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #202124;\n    margin-bottom: 16px;\n}\n\n.profile-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n    color: #5f6368;\n    font-size: 14px;\n}\n\n.profile-item svg {\n    color: #5f6368;\n}\n\n.subscriptions-section,\n.ids-section,\n.tags-section,\n.automations-section {\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 1px solid #e0e0e0;\n}\n\n.subscription-item {\n    background: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 12px;\n    margin-top: 12px;\n}\n\n.subscription-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.subscription-header>div {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    color: #202124;\n}\n\n.subscription-badge {\n    background: #e8eaed;\n    color: #5f6368;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.id-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 0;\n    font-size: 14px;\n    color: #5f6368;\n}\n\n.copy-button,\n.add-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    color: #4346ce;\n    margin-left: auto;\n}\n\n.copy-button:hover,\n.add-button:hover {\n    opacity: 0.7;\n}\n\n.add-tag-button {\n    background: transparent;\n    border: 1px solid #4346ce;\n    color: #4346ce;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 13px;\n    margin-top: 12px;\n    transition: all 0.2s;\n}\n\n.add-tag-button:hover {\n    background: #f0f0ff;\n}\n\n.tags-list {\n    margin-top: 16px;\n}\n\n.automations-link {\n    margin: 0;\n    color: #4346ce;\n    font-size: 14px;\n}\n\n.activity-subtitle {\n    color: #5f6368;\n    font-size: 13px;\n    margin-bottom: 16px;\n}\n\n.days-selector {\n    margin-bottom: 24px;\n}\n\n.days-selector button {\n    background: white;\n    border: 1px solid #dadce0;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #5f6368;\n}\n\n.days-selector button.active {\n    background: #e8f0fe;\n    border-color: #4346ce;\n    color: #4346ce;\n}\n\n.no-activity {\n    text-align: center;\n    padding: 60px 20px;\n}\n\n.no-activity-icon {\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n}\n\n.no-activity h4 {\n    font-size: 18px;\n    font-weight: 600;\n    color: #202124;\n    margin-bottom: 8px;\n}\n\n.no-activity p {\n    color: #5f6368;\n    font-size: 14px;\n}\n\n@media (max-width: 1024px) {\n    .user-profile-content {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Modal Styles */\n/* .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: fadeIn 0.2s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.modal-content {\n    background: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 550px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n    animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 28px;\n    border-bottom: 1px solid #e8eaed;\n}\n\n.modal-header h2 {\n    font-size: 22px;\n    font-weight: 500;\n    color: #202124;\n    margin: 0;\n}\n\n.modal-close {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: #5f6368;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n}\n\n.modal-close:hover {\n    background: #f1f3f4;\n    color: #202124;\n}\n\n.modal-body {\n    padding: 32px 28px;\n} */\n\n.form-group {\n    margin-bottom: 24px;\n}\n\n.form-group:last-child {\n    margin-bottom: 0;\n}\n\n.form-group label {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n    color: #5f6368;\n    margin-bottom: 10px;\n}\n\n.form-input {\n    width: 100%;\n    padding: 12px 14px;\n    border: 1px solid #dadce0;\n    border-radius: 4px;\n    font-size: 15px;\n    color: #202124;\n    transition: all 0.2s;\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n.form-input::placeholder {\n    color: #9aa0a6;\n}\n\n.form-input:hover {\n    border-color: #bdc1c6;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: #5f6df4;\n    box-shadow: 0 0 0 3px rgba(95, 109, 244, 0.1);\n}\n\n/*\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 20px 28px;\n    background: #fafafa;\n    border-top: 1px solid #e8eaed;\n    border-radius: 0 0 8px 8px;\n} */\n\n.btn-cancel {\n    background: transparent;\n    border: none;\n    color: #5f6df4;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n    font-family: inherit;\n}\n\n.btn-cancel:hover {\n    background: #e8eaff;\n}\n\n.btn-save {\n    background: #5f6df4;\n    border: none;\n    color: white;\n    padding: 10px 28px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n    font-family: inherit;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n.btn-save:hover:not(:disabled) {\n    background: #4e5ce6;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.btn-save:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* Bootstrap Modal Overrides */\n.modal.show {\n    display: block;\n}\n\n.modal-dialog-centered {\n    max-width: 550px;\n}\n\n.modal-title {\n    font-size: 22px;\n    font-weight: 500;\n    color: #202124;\n}\n\n.modal-body .form-label {\n    font-size: 14px;\n    font-weight: 400;\n    color: #5f6368;\n    margin-bottom: 8px;\n}\n\n\n.modal-body .mb-3 {\n    margin-bottom: 1.5rem;\n}\n\n/* Tag Dropdown Menu */\n.tag-menu-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.tag-menu-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n    color: #5f6368;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: all 0.2s;\n    line-height: 1;\n}\n\n.tag-menu-button:hover {\n    background: #e8eaed;\n    color: #202124;\n}\n\n.tag-dropdown {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 4px);\n    background: white;\n    border: 1px solid #dadce0;\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);\n    min-width: 168px;\n    z-index: 1000;\n    overflow: hidden;\n    padding: 4px 0;\n    animation: dropdownFadeIn 0.15s ease-out;\n}\n\n@keyframes dropdownFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.tag-dropdown .dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 10px 14px;\n    border: none;\n    background: transparent;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1.25;\n    color: #3c4043;\n    font-weight: 400;\n}\n\n.tag-dropdown .dropdown-item svg {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    display: block;\n}\n\n.tag-dropdown .dropdown-item:hover {\n    background: #f1f3f4;\n    color: #202124;\n}\n\n.tag-dropdown .dropdown-item:active {\n    background: #e8eaed;\n}\n\n.tag-dropdown .dropdown-item.text-danger {\n    color: #d93025;\n}\n\n.tag-dropdown .dropdown-item.text-danger:hover {\n    background: #fce8e6;\n    color: #c5221f;\n}\n\n.tag-dropdown .dropdown-item.text-danger:active {\n    background: #f9dedc;\n}\n\n.tag-item {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.tag-item:hover {\n    background: #f1f3f4;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.tag-item-content {\n    display: flex;\n    gap: 16px;\n    flex: 1;\n    align-items: center;\n}\n\n.tag-item-key {\n    font-weight: 500;\n    color: #202124;\n    min-width: 120px;\n}\n\n.tag-item-value {\n    color: #5f6368;\n    flex: 1;\n}\n\n/* Activity Timeline Styles */\n.activity-timeline {\n    margin-top: 20px;\n}\n\n.activity-item {\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    margin-bottom: 12px;\n    overflow: hidden;\n    transition: all 0.2s;\n}\n\n.activity-item:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.activity-item-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n    background: white;\n    transition: background 0.2s;\n}\n\n.activity-item-header:hover {\n    background: #f8f9fa;\n}\n\n.activity-timestamp {\n    font-size: 13px;\n    color: #5f6368;\n    min-width: 180px;\n}\n\n.activity-status {\n    font-size: 14px;\n    color: #202124;\n    font-weight: 500;\n    flex: 1;\n}\n\n.activity-details {\n    padding: 16px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n}\n\n.activity-details h4 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #202124;\n    margin-bottom: 16px;\n}\n\n.activity-detail-row {\n    display: flex;\n    padding: 10px 0;\n    border-bottom: 1px solid #e8eaed;\n    font-size: 13px;\n}\n\n.activity-detail-row:last-child {\n    border-bottom: none;\n}\n\n.detail-label {\n    color: #5f6368;\n    min-width: 140px;\n    font-weight: 500;\n}\n\n.detail-value {\n    color: #202124;\n    flex: 1;\n    word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
